import { call, put, takeEvery, all, fork } from 'redux-saga/effects';

import {
  GET_BILLS_TO_PAY,
  GET_BILLS_TO_PAY_BY_HASH,
  CREATE_BILLS_TO_PAY,
  UPDATE_BILLS_TO_PAY,
  DELETE_BILLS_TO_PAY,
} from './actionType';

import {
  BillsToPayApiResponseError,
  BillsToPayApiResponseSuccess,
} from './action';

import {
  getBillsToPay as GetBillsToPay,
  getBillsToPayByHash as GetBillsToPayByHash,
  createBillsToPay as CreateBillsToPay,
  updateBillsToPay as UpdateBillsToPay,
  deleteBillsToPay as DeleteBillsToPay,
} from '../../helpers/backend_helper';
import { notifyError, notifySuccess } from '../../components/notify';

function* getBillsToPay({ payload }) {
  try {
    const response = yield call(GetBillsToPay, payload);
    yield put(BillsToPayApiResponseSuccess(GET_BILLS_TO_PAY, response));
  } catch (error) {
    yield put(BillsToPayApiResponseError(GET_BILLS_TO_PAY, error));
  }
}

function* getBillsToPayByHash({ payload }) {
  try {
    const response = yield call(GetBillsToPayByHash, payload.hash);
    yield put(BillsToPayApiResponseSuccess(GET_BILLS_TO_PAY_BY_HASH, response));
  } catch (error) {
    yield put(BillsToPayApiResponseError(GET_BILLS_TO_PAY_BY_HASH, error));
  }
}

function* createBillsToPay({ payload }) {
  try {
    const response = yield call(CreateBillsToPay, payload.data);
    yield put(BillsToPayApiResponseSuccess(CREATE_BILLS_TO_PAY, response));
    notifySuccess('Conta criada com sucesso!');
  } catch (error) {
    yield put(BillsToPayApiResponseError(CREATE_BILLS_TO_PAY, error));
    notifyError('Erro ao criar conta');
  }
}

function* updateBillsToPay({ payload }) {
  try {
    const response = yield call(UpdateBillsToPay, {
      hash: payload.hash,
      data: payload.data,
    });
    yield put(BillsToPayApiResponseSuccess(UPDATE_BILLS_TO_PAY, response));
    notifySuccess('Conta atualizada com sucesso!');
  } catch (error) {
    yield put(BillsToPayApiResponseError(UPDATE_BILLS_TO_PAY, error));
    notifyError('Erro ao atualizar conta');
  }
}

function* deleteBillsToPay(data) {
  try {
    const response = yield call(DeleteBillsToPay, data.payload.hash);
    yield put(BillsToPayApiResponseSuccess(DELETE_BILLS_TO_PAY, response));
    notifySuccess('Conta deletada com sucesso!');
  } catch (error) {
    yield put(BillsToPayApiResponseError(DELETE_BILLS_TO_PAY, error));
    notifyError('Erro ao deletar conta');
  }
}

export function* watchGetBillsToPay() {
  yield takeEvery(GET_BILLS_TO_PAY, getBillsToPay);
}

export function* watchgetBillsToPayByHash() {
  yield takeEvery(GET_BILLS_TO_PAY_BY_HASH, getBillsToPayByHash);
}

export function* watchCreateBillsToPay() {
  yield takeEvery(CREATE_BILLS_TO_PAY, createBillsToPay);
}

export function* watchUpdateBillsToPay() {
  yield takeEvery(UPDATE_BILLS_TO_PAY, updateBillsToPay);
}

export function* watchDeleteBillsToPay() {
  yield takeEvery(DELETE_BILLS_TO_PAY, deleteBillsToPay);
}

function* BillsToPaySaga() {
  yield all([fork(watchGetBillsToPay)]);
  yield all([fork(watchgetBillsToPayByHash)]);
  yield all([fork(watchCreateBillsToPay)]);
  yield all([fork(watchUpdateBillsToPay)]);
  yield all([fork(watchDeleteBillsToPay)]);
}

export default BillsToPaySaga;
